import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/software_management/pages/settings/RootPage'))

const SoftwareManagementSettings = React.lazy(
  () => import('modules/software_management/pages/settings/Settings')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.software.path,
      element: <RootPage />,
      children: [
        {
          handle: {
            meta: () => {
              return { title: i18n.t('company_settings.finance.software.title') }
            },
          },
          element: <SoftwareManagementSettings />,
          index: true,
        },
      ],
    },
  ]
}

export default settingsRoutes
